/* ARGUS PR #164 (CRITICAL): single source for the Tailwind preflight + utility layer.
   tailwind.config.js's `content` glob is global (every .ts file under src/main,
   recursively), so `@tailwind utilities` expands to the SAME full utility set no
   matter which file requests it.
   Previously every component CSS file carried its own `@tailwind base/utilities`,
   so Vite's `?inline` pipeline processed and emitted that identical set once per
   file (5x in the shipped bundle). Importing THIS one file's `?inline` string from
   every component instead makes it a single ES module in the Rollup graph — the
   bytes are emitted once and the resulting CSSStyleSheet is adopted (not copied)
   into each shadow root via `static styles = [unsafeCSS(shared), unsafeCSS(local)]`. */
@tailwind base;
@tailwind utilities;
